const select1 = {
  span: 8,
  label: '创建日期',
  component: 'ASelect',
  prop: 'createTime',
  defaultValue: 'application_date-DESC',
  placeholder: '选择创建日期',
  list: [
    // { label: '收藏日由晚到早', value: 'update_time-DESC' },
    // { label: '收藏日由早到晚', value: 'update_time-ASC' },
    { label: '申请日由早到晚', value: 'application_date-ASC' },
    { label: '申请日由晚到早', value: 'application_date-DESC' },
    { label: '公开日由早到晚', value: 'publication_date-ASC', fav: true },
    { label: '公开日由晚到早', value: 'publication_date-DESC', fav: true },
    { label: '申请号升序', value: 'application_num_sear-ASC', fav: true },
    { label: '申请号降序', value: 'application_num_sear-DESC', fav: true },
    { label: '公开号升序', value: 'publication_number_sear-ASC', fav: true },
    { label: '公开号降序', value: 'publication_number_sear-DESC', fav: true },
    { label: '被引用次数升序', value: 'cited_count-ASC' },
    { label: '被引用次数降序', value: 'cited_count-DESC' },
    { label: '引用次数升序', value: 'citation_count-ASC' },
    { label: '引用次数降序', value: 'citation_count-DESC' },
    { label: '申请人数量升序', value: 'applicants_count-ASC' },
    { label: '申请人数量降序', value: 'applicants_count-DESC' },
    { label: '权利要求数升序', value: 'claims_num-ASC' },
    { label: '权利要求数降序', value: 'claims_num-DESC' }
  ]
}

const select2 = {
  span: 8,
  label: '创建日期',
  component: 'ASelect',
  prop: 'createTime',
  placeholder: '选择创建日期',
  defaultValue: 0,
  list: [
    { label: '未合并', value: 0 },
    { label: '申请号合并', value: 1 },
    { label: '同族合并', value: 2 },
    { label: '合并规则设置', value: 'set' }
  ]
}

const fields = [
  {
    dataIndex: 'name',
    key: 'name',
    title: '需求内容'
  },
  {
    dataIndex: 'demandsTypeStr',
    key: 'demandsType',
    title: '需求类型'
  },
  {
    dataIndex: 'statusStr',
    key: 'status',
    scopedSlots: {
      customRender: 'color'
    },
    title: '状态'
  },
  {
    dataIndex: 'createTime',
    key: 'createTime',
    title: '创建时间'
  },
  {
    title: '操作',
    key: 'action',
    scopedSlots: {
      customRender: 'action'
    }
  }
]

module.exports = {
  select1,
  select2,
  fields
}